import React from 'react';
import NavBarMunicipe from '../components/Navbars/NavBarMunicipe';
import { Route, Routes } from 'react-router-dom';
import { Container } from 'reactstrap';

//Routes
import routes from '../routes/views.routes';

//Context
import { useAuth } from '../context/auth';

export default function AdminMunicipe() {
    const { showNavigation } = useAuth();
    return (
        <div className='content-auth adminMunicipe pb-5'>
            <div className="img-bg"></div>
            {showNavigation && <NavBarMunicipe />}
            <Container>
                <Routes>
                    {
                        routes.filter(route => route.layout == "/municipe").map((route, key) => {
                            const Screen = route.component;
                            return (
                                <Route
                                    path={route.path}
                                    element={<Screen />}
                                    key={key}
                                />
                            )
                        })
                    }
                </Routes>
            </Container>
        </div>
    )
}